import React from 'lib/react';
import {
  EVGrid, EVRadio, EVInputLabel, EVTypography,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import { useSelector, useDispatch } from 'lib/redux';
import { updateInputFieldValue, cancelOrderPreferencesChanges } from 'features/orderPreferences/OrderPreferences.actions';
import { getPropertyValues } from 'features/orderPreferences/OrderPreferences.utils';
import { STRUCTURE_TYPES } from '../ProductSelection.utils';
import ProductSelectionStyles from '../ProductSelectionStyles';

function StructureType() {
  const { t } = useTranslation();
  const classes = ProductSelectionStyles();
  const dispatch = useDispatch();

  const orderPreferences = useSelector(({ userData }) => userData.orderPreferences);
  const inputFieldValues = useSelector(({ orderPreference }) => orderPreference.inputFieldValues);
  const activeValue = STRUCTURE_TYPES[getPropertyValues(orderPreferences, inputFieldValues, 'structureType').value];
  const onStructureChange = (e) => {
    dispatch(cancelOrderPreferencesChanges());
    dispatch(updateInputFieldValue('structureType', 'value', Number(e.target.value)));
  };

  return (
    <EVGrid className={classes.structureTypeContainer}>
      {Object.keys(STRUCTURE_TYPES).map((key) => (
        <EVGrid item className={classes.propertyTypeRadio} key={key}>
          <EVRadio
            checked={activeValue ? STRUCTURE_TYPES[key] === activeValue : STRUCTURE_TYPES[key] === STRUCTURE_TYPES[1]}
            onChange={onStructureChange}
            color="primary"
            id={STRUCTURE_TYPES[key]}
            value={key}
            inputProps={{ 'aria-label': STRUCTURE_TYPES[key] }}
            className={classes.structureTypeRadio}
          />
          <EVInputLabel htmlFor={STRUCTURE_TYPES[key]}>
            <EVTypography className={classes.structureTypeText}>{t(STRUCTURE_TYPES[key])}</EVTypography>
          </EVInputLabel>
        </EVGrid>
      ))}
    </EVGrid>
  );
}

export default StructureType;
